module.exports = __webpack_public_path__ + "img/箭头.7484ba45.svg";